import styled, { css } from "styled-components";
import { ProductImageVariant } from "../components/ProductImage";

interface StyleProps {
  $variant: ProductImageVariant;
}

const highlightVariant = css`
  position: relative;
  height: 100%;
  width: 100%;
  margin-bottom: 10px;

  & .akn-live-tag {
    border-radius: 5px;
  }

  & .akn-product-image {
    min-height: 100px;
    height: 185px;
    object-fit: contain;
    width: 100%;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom: 3px solid var(--live-button-color);

    @media (max-width: 1225px) {
      width: auto;
      max-height: 100px;
      position: relative;
      border-radius: 15px;
      border-bottom: none;
    }
  }

  @media (max-width: 1225px) {
    right: 5px;
    top: -85px;
    position: absolute;
  }
`;
const modalVariant = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 5px;
  background: white;
  background-size: 100% 5px;
  height: auto;

  & .akn-live-tag {
    content: "LIVE";
    padding: 2px 5px;
    font-weight: bold;
    border-radius: 2px;
    background: linear-gradient(to left, #f4ff00, #71d200);
    left: 13px;
    top: 13px;
    bottom: unset;
    font-size: 9px;
  }

  & .akn-product-image {
    height: 100%;
    width: 100%;
    max-height: 45vh;
    position: relative;
    height: 100%;
    @media (max-width: 700px) {
      max-height: 28vh;
      height: 100%;
    }
  }
`;

const combinedVariant = css`
  margin-right: 4px;

  @media (max-width: 1225px) {
    right: unset;
    top: unset;
    position: unset;
  }
`;

function getVariant(variant: ProductImageVariant) {
  if (variant === "highlight") return highlightVariant;
  if (variant === "combined") return ` ${highlightVariant}  ${combinedVariant}`;
  if (variant === "modal") return modalVariant;
  return "";
}

export const DivProductImage = styled.div<StyleProps>`
  position: relative;

  & .akn-live-tag {
    position: absolute;
    left: 20px;
    top: 20px;
    padding: 2px 8px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 2px;
    background: linear-gradient(to left, #f4ff00, #71d200);
    z-index: 1;
  }

  @media (max-width: 1225px) {
    width: auto;

    .akn-live-tag {
      height: 15px;
      min-height: unset;
      left: 10px;
      bottom: 10px;
      top: unset;
      padding: 0 6px;
    }
  }

  & .akn-product-image {
    height: 185px;
    min-height: 100px;
    object-fit: contain;
    width: 100%;
    @media (max-width: 1225px) {
      .akn-product-image {
        width: 100%;
      }
    }
  }

  ${({ $variant }) => getVariant($variant)}
`;
